
import { ResultData } from "@nt-portal/common-sdk";

import { TCMMasterGroupSheet, TCMScheduleSheet, TCMScheduleSheetService } from "@nt-portal/tcm-sdk";
import { ControllerOptions, DataController } from "../../../../types";
import { BaseClientService } from "../../base-client.service";




export interface TCMScheduleSheetOptions extends ControllerOptions<TCMScheduleSheet> {

}

export const createTCMScheduleSheet = (inObj: Partial<TCMScheduleSheet>) => {

    let groupSheet: TCMMasterGroupSheet = {
        id: "",
        name: "",
        group: {id: "", name: "", createdBy: "", groupNumber: "", groupId: 0},
        sheetFields: [],
        order: 0,
        createdBy: ""
    }

    let item: TCMScheduleSheet = {
        id: "",
        schedule: inObj.schedule ?? {
            id: "",
            name: "",
            createdBy: "",
            rankingCalculationPoints: 0,
            rankingCalculationPrice: 0
        },
        createdBy: "",
        name: "",
        order: 0,
        groupSheet: groupSheet,
        fields: []
    }
    return item;
}

export class ClientTCMScheduleSheetService extends BaseClientService implements DataController<TCMScheduleSheet> {

    private _service: TCMScheduleSheetService;


    constructor() {
        super();
        this._service = new TCMScheduleSheetService({
            apiService: this.apiService,
            url: this.settings.tcmServer
        });
    }

    public set params(params: any) {
        this._service.params = params;
    }

    public get params() {
        return this._service.params ?? {};
    }

    public async get(options: TCMScheduleSheetOptions): Promise<ResultData<TCMScheduleSheet>> {


        return await this._service.get(this.buildFetchParams(options), this.token, options.filter);

    }
    public async getLookup(options: TCMScheduleSheetOptions): Promise<ResultData<TCMScheduleSheet>> {
        let fetchParams = this.buildLookupFetchParams(options);
        let data = await this._service.get(fetchParams, this.token);
        return data;
    }

    public async getById(options: TCMScheduleSheetOptions): Promise<TCMScheduleSheet | null> {
        if (options.id) {
            let item = await this._service.getById(options.id, this.token);
            return item;
        }
        return null;
    }
    public async delete(options: TCMScheduleSheetOptions): Promise<any> {
        if (options.id)
            await this._service.delete(options.id, this.token);
    }
    public async update(options: TCMScheduleSheetOptions): Promise<TCMScheduleSheet | TCMScheduleSheet[] | null> {
        if (options.item && options.item.id)
            return await this._service.update(options.item.id, options.item, this.token)
        return null;
    }
    public async add(options: TCMScheduleSheetOptions): Promise<TCMScheduleSheet | TCMScheduleSheet[] | null> {
        if (options.item)
            return await this._service.add(options.item, this.token)
        return null;
    }

    //  public async validateName(name: string, id?: string): Promise<ValidateResult> {
    //        return await this._service.validateName(name, this.token, id)
    //    }
   

   


}